import * as types from "../actionTypes";
import { PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_REQUEST } from "../actionTypes";

export const get = (pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_REVIEW_REQUEST,
    pageNumber
  };
};

export const getSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_MONTHLY_REVIEW_FAILURE,
    error: error
  };
};

export const getDetail = (filter, pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_REQUEST,
    filter: filter,
    pageNumber
  };
};

export const getDetailSuccess = data => {
  return {
    type: types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const getDetailFailure = error => {
  return {
    type: types.PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_FAILURE,
    error: error
  };
};

export const remove = (id, accountType, pageNumber = null) => {
  return {
    type: types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_REQUEST,
    id: id,
    account_type: accountType,
    pageNumber
  };
};

export const removeSuccess = data => {
  return {
    type: types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_SUCCESS,
    payLoad: data
  };
};
export const removeFailure = error => {
  return {
    type: types.PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_FAILURE,
    error: error
  };
};

export const showByAccountTitles = (filters, pageNumber) => {
  return {
    type: types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_REQUEST,
    filters: filters,
    pageNumber
  };
};

export const showByAccountTitlesSuccess = data => {
  return {
    type: types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_SUCCESS,
    payLoad: data
  };
};
export const showByAccountTitlesFailure = error => {
  return {
    type: types.PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_FAILURE,
    error: error
  };
};
